/* eslint-disable import/prefer-default-export */
/**
 * Build checklist payload for hazard_index_underwriter — matches RiskCheckListEdit save() logic.
 */
export function buildUnderwriterChecklistQuestionsToSave(riskValues, checkedList, riskChecklist) {
  const questionString = (questionId) =>
    riskChecklist.find((risk) => Number(risk.id) === Number(questionId))?.title;

  const answersForms = Object.entries(riskValues || {}).map(([key, value]) => ({
    questionId: +key,
    answer: value,
    question: questionString(key),
  }));

  const checkedQuestions = (checkedList || [])
    .filter((questionId) => riskValues[questionId] === undefined)
    .map((questionId) => ({
      questionId,
      question: questionString(questionId),
    }));

  return [...answersForms, ...checkedQuestions];
}
